import { select, Selector, SelectorWithProps, Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";
import { RootState } from "src/app/ngrx/root-reducers";

// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
export function takeLatestFrom<T = unknown>(
  store: Store<RootState>,
  selector: Selector<RootState, T> | SelectorWithProps<RootState, Record<string, any>, any>,
  props?: Record<string, any>
): T {
  let state: T;
  store.pipe(select(selector, props), take(1)).subscribe((value) => (state = value));
  return state;
}

/**
 * Returns the event count index and the incomming value
 */
export const counter =
  () =>
  <T>(source: Observable<T>): Observable<{ index: number; value: T }> => {
    let index = 0;
    return new Observable((subscriber) => {
      source.subscribe({
        next(value: T) {
          subscriber.next({ index: index++, value });
        },
        error(error: any) {
          subscriber.error(error);
        },
        complete() {
          subscriber.complete();
        }
      });
    });
  };
